/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamItemSubTypesQueryResponse,
  GetApiV1ExamItemSubTypes400,
  GetApiV1ExamItemSubTypes401,
  GetApiV1ExamItemSubTypes500,
} from "../../types/examSharedController/GetApiV1ExamExamItemSubTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamItemSubTypes } from "../../clients/examSharedController/getApiV1ExamExamItemSubTypes.ts";

export const getApiV1ExamExamItemSubTypesQueryKey = () =>
  [{ url: "/api/v1/exam/exam-item-sub-types" }] as const;

export type GetApiV1ExamExamItemSubTypesQueryKey = ReturnType<
  typeof getApiV1ExamExamItemSubTypesQueryKey
>;

export function getApiV1ExamExamItemSubTypesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamItemSubTypesQueryKey();
  return queryOptions<
    GetApiV1ExamItemSubTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamItemSubTypes400
      | GetApiV1ExamItemSubTypes401
      | GetApiV1ExamItemSubTypes500
    >,
    GetApiV1ExamItemSubTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamItemSubTypes({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os sub tipos de componentes para questões do tipo aberta e multipla linha **(Requer Authorization para autenticação)**
 * @summary Buscar todos os sub tipos de componentes para questões do tipo aberta e multipla linha (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-item-sub-types}
 */
export function useGetApiV1ExamExamItemSubTypes<
  TData = GetApiV1ExamItemSubTypesQueryResponse,
  TQueryData = GetApiV1ExamItemSubTypesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamItemSubTypesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamItemSubTypesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamItemSubTypes400
          | GetApiV1ExamItemSubTypes401
          | GetApiV1ExamItemSubTypes500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamExamItemSubTypesQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamExamItemSubTypesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamItemSubTypes400
      | GetApiV1ExamItemSubTypes401
      | GetApiV1ExamItemSubTypes500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
